import Style from "@homer.core/style";

const tasks = new Map();

/**
 * Shares style loads across fragments while keeping failed dependencies retryable.
 * @param {string} id Public style identifier.
 * @returns {Promise<unknown>} Shared style load.
 */
export default function obtainStyle(id) {
    let task = tasks.get(id);

    if (!task) {
        // Convert synchronous provider failures into the same retryable Promise path.
        task = Promise.resolve().then(() => Style.obtain(id));
        tasks.set(id, task);
        void task.catch(() => {
            if (tasks.get(id) === task) tasks.delete(id);
        });
    }

    return task;
}
